import { render, staticRenderFns } from "./number-input.generic.vue?vue&type=template&id=055ac104&"
import script from "./number-input.generic.vue?vue&type=script&lang=js&"
export * from "./number-input.generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports